export const colorMapper = (color) => ({
    main: color['70'],
    50: color['100'],
    100: color['98'],
    200: color['95'],
    300: color['90'],
    400: color['80'],
    500: color['70'],
    600: color['60'],
    700: color['50'],
    800: color['40'],
    900: color['30'],
    A100: color['20'],
    A200: color['10'],
    A400: color['0'],
});
